import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  const isPrivacy = type === 'privacy';
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-65">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} className="bg-parchment rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden border border-gold/20" onClick={e => e.stopPropagation()} data-id="element-66">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-parchment-dark bg-white" data-id="element-67">
          <h2 className="text-xl font-bold text-navy font-serif" data-id="element-68">
            {isPrivacy ? 'Política de Privacidad' : 'Términos y Condiciones'}
          </h2>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-parchment transition-colors text-charcoal" aria-label="Cerrar" data-id="element-69">
            <XIcon className="w-5 h-5" data-id="element-70" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-charcoal leading-relaxed space-y-4 text-sm" data-id="element-71">
          {isPrivacy ? <>
              <p className="text-xs text-gray-400 uppercase tracking-wider font-bold" data-id="element-72">
                Última actualización: Marzo 2026
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-73">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-74">
                Al realizar una compra en nuestro sitio, recopilamos únicamente
                la información necesaria para procesar tu pedido: nombre,
                dirección de correo electrónico y datos de pago. No almacenamos
                datos de tarjetas de crédito en nuestros servidores; estos son
                procesados de forma segura por nuestro proveedor de pagos.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-75">
                2. Uso de la Información
              </h3>
              <p data-id="element-76">Tu información personal se utiliza exclusivamente para:</p>
              <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-77">
                <li data-id="element-78">Procesar y entregar tu compra digital.</li>
                <li data-id="element-79">Enviarte el producto adquirido por correo electrónico.</li>
                <li data-id="element-80">
                  Comunicarnos contigo en caso de problemas con tu pedido.
                </li>
              </ul>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-81">
                3. Protección de Datos
              </h3>
              <p data-id="element-82">
                Implementamos medidas de seguridad estándar de la industria para
                proteger tu información personal. Utilizamos cifrado SSL para
                todas las transacciones y no compartimos, vendemos ni alquilamos
                tu información personal a terceros.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-83">
                4. Cookies
              </h3>
              <p data-id="element-84">
                Nuestro sitio puede utilizar cookies básicas para mejorar tu
                experiencia de navegación y analizar el tráfico del sitio de
                forma anónima.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-85">
                5. Tus Derechos
              </h3>
              <p data-id="element-86">
                Tienes derecho a solicitar acceso, corrección o eliminación de
                tus datos personales en cualquier momento. Para ejercer estos
                derechos, puedes comunicarte con nosotros a través de los
                canales disponibles.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-87">
                6. Cambios a esta Política
              </h3>
              <p data-id="element-88">
                Nos reservamos el derecho de actualizar esta política de
                privacidad en cualquier momento. Los cambios serán publicados en
                esta página con la fecha de actualización correspondiente.
              </p>
            </> : <>
              <p className="text-xs text-gray-400 uppercase tracking-wider font-bold" data-id="element-89">
                Última actualización: Marzo 2026
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-90">
                1. Producto Digital
              </h3>
              <p data-id="element-91">
                "El Código de Habacuc" es un producto digital (eBook en formato
                PDF) con materiales complementarios. Al completar tu compra,
                recibirás acceso inmediato al contenido descargable.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-92">
                2. Uso Personal
              </h3>
              <p data-id="element-93">
                El contenido adquirido es para uso personal y no comercial.
                Queda prohibida la reproducción, distribución, modificación o
                reventa total o parcial del material sin autorización expresa
                por escrito del autor.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-94">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-95">
                Todo el contenido, incluyendo textos, plantillas, guías y
                materiales complementarios, es propiedad intelectual de J.C.
                Adrianza y está protegido por las leyes de derechos de autor
                aplicables.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-96">
                4. Política de Reembolso
              </h3>
              <p data-id="element-97">
                Debido a la naturaleza digital e inmediata del producto, todas
                las ventas son finales. No se ofrecen reembolsos una vez que el
                contenido ha sido entregado y descargado.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-98">
                5. Descargo de Responsabilidad
              </h3>
              <p data-id="element-99">
                Este producto es de naturaleza educativa y espiritual. Los
                resultados pueden variar según la dedicación y circunstancias
                individuales de cada persona. No garantizamos resultados
                financieros específicos. El contenido no constituye asesoría
                financiera, legal ni profesional.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-100">
                6. Aceptación de Términos
              </h3>
              <p data-id="element-101">
                Al realizar tu compra, confirmas que has leído, entendido y
                aceptado estos términos y condiciones en su totalidad.
              </p>

              <h3 className="text-lg font-bold text-navy font-serif mt-4" data-id="element-102">
                7. Modificaciones
              </h3>
              <p data-id="element-103">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. Las modificaciones entrarán en vigor desde su
                publicación en esta página.
              </p>
            </>}
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark text-gray-300 py-8 text-center border-t border-navy-light/20" data-id="element-104">
        <div className="container mx-auto px-4" data-id="element-105">
          <p className="text-sm opacity-50 mb-4" data-id="element-106">
            © {new Date().getFullYear()} El Código de Habacuc. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-4 text-sm" data-id="element-107">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-gold transition-colors underline underline-offset-2 decoration-gray-700 hover:decoration-gold" data-id="element-108">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-109">•</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-gold transition-colors underline underline-offset-2 decoration-gray-700 hover:decoration-gold" data-id="element-110">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-111">
        {activeModal && <LegalModal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-112" />}
      </AnimatePresence>
    </>;
}